import { Autocomplete, TextField } from "@mui/material";
import { MRT_Row } from "material-react-table";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { BookingScheduleInterface } from "../../Booking-Form/typings/booking.types";
import { LocationInventory } from "../../FloorManager/typings/location-inventory";
import { isVisitorAdminScheduleFieldEditable } from "./visitor-bookings-table.partial";

type VisitorLocationOption = {
  id: string;
  name: string;
};

type P = {
  row: MRT_Row<BookingScheduleInterface>;
  locations: LocationInventory[] | undefined;
};

export function VisitorBookingsLocationEdit({ row, locations }: P) {
  const { t } = useTranslation();
  const disabled = !isVisitorAdminScheduleFieldEditable(row.original, "location");

  const locationOptions = useMemo(() => {
    const remoteLocations = (locations ?? [])
      .map(location => {
        const locationName = location.name?.trim();
        return locationName ? { id: String(location.id), name: locationName } : null;
      })
      .filter((location): location is VisitorLocationOption => Boolean(location));
    const uniqueByName = Array.from(
      new Map(remoteLocations.map(item => [item.name, item])).values()
    );
    const fallback = row.original.locationName?.trim();
    if (fallback && !uniqueByName.some(option => option.name === fallback)) {
      uniqueByName.push({ id: fallback, name: fallback });
    }

    return uniqueByName;
  }, [locations, row.original.locationName]);

  const selected =
    locationOptions.find(option => option.name === row.original.locationName) ?? null;

  return (
    <Autocomplete
      options={locationOptions}
      fullWidth
      disabled={disabled}
      value={selected}
      getOptionLabel={option => option.name}
      isOptionEqualToValue={(a, b) => a.id === b.id}
      onChange={(_, value) => {
        row._valuesCache.locationName = value?.name ?? "";
      }}
      renderInput={params => (
        <TextField
          {...params}
          variant="standard"
          label={t("_visitorBookings_colLocation")}
          placeholder={t("_visitorBookings_colLocation")}
        />
      )}
    />
  );
}
